// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"350":"67f130c693fcfab48258","374":"eb2be743c5966d3ea417","660":"37ae14323c5792b31152","826":"bef4b1ddd0a43e08dfea","896":"1178f9eb160145195441"}[chunkId] + ".bundle.js";
};